<page-toolbar [pageActions]="pageActions" [title]="title"></page-toolbar>

<page-content>
  <div class="content">
    <data-table #table (remove)="onDelete($event)" [searchAll]="true"
                    [columns]="columns" [dataProviderParams]="dataProviderParams" [dataProvider]="groupHasRolesInOrganisationsService">
    </data-table>

    <button (click)="addRole()" class="add-button" color="primary" mat-mini-fab>
      <mat-icon class="mat-24">add</mat-icon>
    </button>
  </div>
</page-content>
